(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-banner"] && !Shopify.designMode) return;
  try {
    
  // Function to handle video autoplay with iOS support
  const handleVideoAutoplay = () => {
    const videos = document.querySelectorAll('video[data-mobile-autoplay="true"]');

    // Try to autoplay videos
    const playVideo = (video) => {
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          // If autoplay fails, add a one-time touch event to start the video
          const playOnTouch = function () {
            video.play();
            video.removeEventListener('touchstart', playOnTouch);
          };
          video.addEventListener('touchstart', playOnTouch, { once: true });
        });
      }
    };

    // Play all autoplay videos
    videos.forEach((video) => {
      // If video is already playing, do nothing
      if (!video.paused) return;

      // Show videos that were hidden
      if (window.innerWidth < 768) {
        video.classList.remove('hidden');
        // Hide the mobile poster once video is ready
        const section = video.closest('.section-media-banner');
        if (section) {
          const poster = section.querySelector('.mobile-poster');
          if (poster) poster.classList.add('hidden');
        }
      }

      // Try to play the video
      playVideo(video);

      // For iOS, we need to handle the first touch event
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        const playOnce = function () {
          playVideo(video);
          document.removeEventListener('touchstart', playOnce);
        };
        document.addEventListener('touchstart', playOnce, { once: true });
      }
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    // After first paint, allow videos to begin buffering quietly
    requestAnimationFrame(() => {
      document.querySelectorAll('.section-media-banner video').forEach((v) => {
        v.preload = 'auto';
        if (typeof v.load === 'function') v.load();
      });
    });

    // Run on initial load
    handleVideoAutoplay();

    // Run again after a short delay to catch any videos that might have loaded late
    setTimeout(handleVideoAutoplay, 1000);

    // Also run on page load complete in case videos are loaded dynamically
    window.addEventListener('load', handleVideoAutoplay);

    // Original video sequence functionality
    setTimeout(function () {
      // Group videos by section ID
      const sections = {};
      const allSequenceVideos = document.querySelectorAll('video[data-sequence="true"]');

      // Group videos by their section ID
      allSequenceVideos.forEach((video) => {
        const sectionId = video.dataset.sectionId;
        if (!sections[sectionId]) {
          sections[sectionId] = [];
        }
        sections[sectionId].push(video);
      });

      // Initialize each section's video sequence separately
      Object.keys(sections).forEach((sectionId) => {
        const sequenceVideos = sections[sectionId];
        console.log(`Media Banner ${sectionId}: Found ${sequenceVideos.length} video elements`);

        if (sequenceVideos.length > 1) {
          // Function to play the next video in sequence
          const playNextVideo = function (currentIndex) {
            const nextIndex = (currentIndex + 1) % sequenceVideos.length;
            const currentVideo = sequenceVideos[currentIndex];
            const nextVideo = sequenceVideos[nextIndex];

            // Hide current video
            currentVideo.classList.add('opacity-0');
            currentVideo.classList.remove('opacity-100');
            currentVideo.pause();

            // Show and play next video
            nextVideo.classList.remove('opacity-0');
            nextVideo.classList.add('opacity-100');
            nextVideo.currentTime = 0;
            const playPromise = nextVideo.play();

            if (playPromise !== undefined) {
              playPromise.catch(function (error) {
                console.error('Media Banner: Video play error:', error);
              });
            }

            // Set up the next video's ended event
            nextVideo.addEventListener(
              'ended',
              function () {
                playNextVideo(nextIndex);
              },
              { once: true },
            );
          };

          // Set up the first video's ended event
          sequenceVideos[0].addEventListener(
            'ended',
            function () {
              playNextVideo(0);
            },
            { once: true },
          );

          console.log(`Media Banner ${sectionId}: Video sequence initialized`);
        }
      });
    }, 200); // Small delay to ensure DOM is fully processed
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["organism-bv-reviews"] && !Shopify.designMode) return;
  try {
    
class ReviewsComponent {
  constructor() {
    this.currentPage = 1;
    this.pageSize = 5;
    this.currentRatingFilter = 'all';
    this.reviews = [];
    this.totalReviews = 0;
    
    // Initialize when the DOM is loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  async init() {
    try {
      await this.fetchReviews();
      this.setupEventListeners();
    } catch (error) {
      console.error('Failed to initialize reviews:', error);
      this.showError('Failed to load reviews. Please refresh the page to try again.');
    }
  }

  async fetchReviews() {
    const container = document.getElementById('reviews-list');
    if (!container) return;

    try {
      // Show loading state
      container.innerHTML = `
        <div class="text-center py-12">
          <div class="animate-pulse flex flex-col items-center">
            <div class="h-4 bg-gray-200 rounded w-1/4 mb-4"></div>
            <div class="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>`;

      const shopDomain = window.shopDomain;
      const apiUrl = `https://judge.me/api/v1/reviews?shop_domain=${shopDomain}&page=${this.currentPage}&per_page=${this.pageSize}${this.currentRatingFilter !== 'all' ? `&rating=${this.currentRatingFilter}` : ''}`;
      
      const response = await fetch(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': '54jvPaYjcLYjMJ0xUwtEsexdZvA' // Public API token
        }
      });
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const data = await response.json();
      this.reviews = data.reviews || [];
      this.totalReviews = data.meta?.reviews_count || 0;
      
      this.renderReviews();
      this.renderPagination();
    } catch (error) {
      console.error('Error fetching reviews:', error);
      this.showError('Failed to load reviews. Please try again later.');
    }
  }

  renderReviews() {
    const container = document.getElementById('reviews-list');
    if (!container) return;

    if (this.reviews.length === 0) {
      container.innerHTML = '<p class="text-center py-12 text-gray-500">No reviews found matching your criteria.</p>';
      return;
    }

    container.innerHTML = this.reviews.map(review => `
      <div class="review-card">
        <div class="review-header">
          <div>
            <div class="reviewer">${this.escapeHtml(review.reviewer?.name || 'Anonymous')}</div>
            <div class="review-rating" aria-label="${review.rating} out of 5 stars">
              ${'★'.repeat(review.rating)}${'☆'.repeat(5 - review.rating)}
            </div>
          </div>
          <div class="review-date">${new Date(review.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</div>
        </div>
        ${review.title ? `<h3 class="review-title">${this.escapeHtml(review.title)}</h3>` : ''}
        <div class="review-body">${this.formatReviewBody(review.body || '')}</div>
        ${review.product ? `<div class="mt-4 text-sm text-gray-600">Product: ${this.escapeHtml(review.product.title)}</div>` : ''}
      </div>
    `).join('');
  }

  renderPagination() {
    const totalPages = Math.ceil(this.totalReviews / this.pageSize);
    const pagination = document.getElementById('pagination');
    if (!pagination) return;

    if (totalPages <= 1) {
      pagination.innerHTML = '';
      return;
    }

    let paginationHTML = '';
    
    // Previous button
    if (this.currentPage > 1) {
      paginationHTML += `
        <button class="pagination-btn" data-page="${this.currentPage - 1}" aria-label="Previous page">
          &larr; Previous
        </button>`;
    } else {
      paginationHTML += `
        <button class="pagination-btn opacity-50 cursor-not-allowed" disabled aria-disabled="true">
          &larr; Previous
        </button>`;
    }

    // Page numbers
    const maxPagesToShow = 5;
    let startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = startPage + maxPagesToShow - 1;
    
    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    if (startPage > 1) {
      paginationHTML += `
        <button class="pagination-btn" data-page="1">1</button>
        ${startPage > 2 ? '<span class="px-2">...</span>' : ''}`;
    }

    for (let i = startPage; i <= endPage; i++) {
      paginationHTML += `
        <button class="pagination-btn ${i === this.currentPage ? 'active' : ''}" data-page="${i}" ${i === this.currentPage ? 'aria-current="page"' : ''}>
          ${i}
        </button>`;
    }

    if (endPage < totalPages) {
      paginationHTML += `
        ${endPage < totalPages - 1 ? '<span class="px-2">...</span>' : ''}
        <button class="pagination-btn" data-page="${totalPages}">${totalPages}</button>`;
    }

    // Next button
    if (this.currentPage < totalPages) {
      paginationHTML += `
        <button class="pagination-btn" data-page="${this.currentPage + 1}" aria-label="Next page">
          Next &rarr;
        </button>`;
    } else {
      paginationHTML += `
        <button class="pagination-btn opacity-50 cursor-not-allowed" disabled aria-disabled="true">
          Next &rarr;
        </button>`;
    }

    pagination.innerHTML = paginationHTML;
  }

  setupEventListeners() {
    // Filter buttons
    document.addEventListener('click', (e) => {
      const filterBtn = e.target.closest('.filter-btn');
      if (filterBtn && !filterBtn.classList.contains('active')) {
        document.querySelector('.filter-btn.active')?.classList.remove('active');
        filterBtn.classList.add('active');
        this.currentRatingFilter = filterBtn.dataset.rating;
        this.currentPage = 1;
        this.fetchReviews();
      }

      // Pagination buttons
      const pageBtn = e.target.closest('.pagination-btn:not([disabled])');
      if (pageBtn && pageBtn.dataset.page) {
        this.currentPage = parseInt(pageBtn.dataset.page);
        this.fetchReviews();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  escapeHtml(unsafe) {
    if (!unsafe) return '';
    return unsafe
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  formatReviewBody(body) {
    if (!body) return '';
    // Convert newlines to <br> and escape HTML
    return this.escapeHtml(body).replace(/\n/g, '<br>');
  }

  showError(message) {
    const container = document.getElementById('reviews-list') || document.querySelector('.reviews-component');
    if (container) {
      container.innerHTML = `
        <div class="text-center py-12">
          <p class="text-red-500">${message}</p>
          <button onclick="location.reload()" class="mt-4 px-4 py-2 bg-black text-white rounded hover:bg-gray-800">
            Try Again
          </button>
        </div>`;
    }
  }
}

// Initialize the reviews component
window.reviewsComponent = new ReviewsComponent();

  } catch(e) { console.error(e); }
})();
})();
